export const setCSSGlobalVariable = (
  idElement: string,
  searchParam: "width" | "height",
  globalVariableName: string
) => {
  if (!idElement || !searchParam || !globalVariableName) {
    return;
  }

  const element = document.getElementById(idElement);

  if (element) {
    const param =
      element[searchParam === "height" ? "clientHeight" : "clientWidth"];

    document.documentElement.style.setProperty(
      `--${globalVariableName}`,
      `${param}px`
    );
  }
};
